export const DEVICE_PRESETS = [
  { id: "responsive", label: "Responsive", width: null, height: null },
  { id: "iphone-se", label: "iPhone SE", width: 375, height: 667 },
  { id: "iphone-14-pro", label: "iPhone 14 Pro", width: 393, height: 852 },
  { id: "iphone-14-pro-max", label: "iPhone 14 Pro Max", width: 430, height: 932 },
  { id: "pixel-7", label: "Pixel 7", width: 412, height: 915 },
  { id: "ipad-mini", label: "iPad Mini", width: 768, height: 1024 },
  { id: "ipad-air", label: "iPad Air", width: 820, height: 1180 },
  { id: "ipad-pro", label: "iPad Pro", width: 1024, height: 1366 },
  { id: "surface-pro-7", label: "Surface Pro 7", width: 912, height: 1368 },
  { id: "nest-hub", label: "Nest Hub", width: 1024, height: 600 },
  { id: "laptop", label: "Laptop", width: 1366, height: 768 },
  { id: "laptop-l", label: "Laptop L", width: 1440, height: 900 },
  { id: "desktop", label: "Desktop", width: 1920, height: 1080 },
];

export function getDevicePreset(id) {
  return DEVICE_PRESETS.find((p) => p.id === id) || DEVICE_PRESETS[0];
}
